export default __webpack_public_path__ + "img/bcgRGKQk.fe68f556.svg";